var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPk = function SvgPk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-75 -40 120 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-75-40H45v80H-75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#01411C",
    d: "M-45-40h90v80h-90z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 24,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: -7,
    cy: -40,
    r: 22,
    fill: "#01411C",
    transform: "rotate(-41.634 45 -40)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m8.751-17.959 10.11 11.373L3.997-9.844l13.94-6.1-7.692 13.129z"
  })));
};
export default SvgPk;